import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const AnimatedBox = styled(Box)({
  width: '31.33%', // 3つのボックスで等分
  height: '31.33%', // 3つのボックスで等分
  backgroundColor: '#60A5FA', // blue-400
  borderRadius: 2,
  opacity: 0,
  position: 'absolute',
});

const ProgressSlider = styled(Box)({
  position: 'absolute',
  height: '100%',
  width: 24,
  background: 'linear-gradient(90deg, #3B82F6, #A855F7, #EC4899)', // blue-500, purple-500, pink-500
});

export default function ComplexLoading({label = ""}) {
  const [progress, setProgress] = useState(-20);

  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev >= 120) return -20;
        return prev + 2;
      });
    }, 20);
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '12rem',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          width: '8rem',
          height: '8rem',
          borderRadius: 2,
          position: 'relative',
          mb: 2,
          overflow: 'hidden',
        }}
      >
        {[...Array(9)].map((_, i) => {
          const col = i % 3;
          const row = Math.floor(i / 3);
          const leftPos = col * 33.33; // パーセンテージで等分
          const topPos = row * 33.33;  // パーセンテージで等分
          
          return (
            <AnimatedBox
              key={i}
              sx={{
                left: `${leftPos}%`,
                top: `${topPos}%`,
                animation: `gridFade 2s infinite ${i * 0.1}s`,
              }}
            />
          );
        })}
      </Box>

      <Box
        sx={{
          position: 'relative',
          width: '6rem',
          height: '0.25rem',
          bgcolor: '#374151', // gray-700
          borderRadius: '1rem',
          overflow: 'hidden',
        }}
      >
        <ProgressSlider
          sx={{
            left: `${progress}%`,
            transform: 'translateX(-50%)',
          }}
        />
      </Box>

      <Typography
        variant="h6"
        sx={{
          mt: 1,
          background: 'linear-gradient(90deg, #3B82F6, #A855F7, #EC4899)',
          backgroundClip: 'text',
          color: 'transparent',
          animation: 'pulse 2s ease-in-out infinite',
          fontWeight: 'bold',
        }}
      >
        {label}
      </Typography>

      <style>{`
        @keyframes gridFade {
          0%, 100% { 
            opacity: 0; 
            transform: scale(0.5); 
          }
          50% { 
            opacity: 0.4; 
            transform: scale(1.1); 
          }
        }
        @keyframes pulse {
          0%, 100% { opacity: 0.7; }
          50% { opacity: 1; }
        }
      `}</style>
    </Box>
  );
}